import {useCallback, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {ConnectionStatusNotificationType} from '../incase-domain/connectionStatus';
import {updateConnectionStatusAction} from '../store/actions/connectionStatus.actions';

const getOnLineStatus = (): boolean =>
    typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean' ? navigator.onLine : true;

export const useNavigatorOnLine = (): boolean => {
    const [status, setStatus] = useState(getOnLineStatus);
    const dispatch = useDispatch();

    const setOnline = useCallback((): void => {
        setStatus(true);
        dispatch(updateConnectionStatusAction({type: ConnectionStatusNotificationType.SUCCESS, message: 'connectionStatus.connected'}));
    }, [dispatch]);

    const setOffline = useCallback((): void => {
        setStatus(false);
        dispatch(
            updateConnectionStatusAction({
                type: ConnectionStatusNotificationType.ERROR,
                message: 'connectionStatus.notConnected',
                hidden: false,
            })
        );
    }, [dispatch]);

    useEffect(() => {
        window.addEventListener('online', setOnline);
        window.addEventListener('offline', setOffline);

        return () => {
            window.removeEventListener('online', setOnline);
            window.removeEventListener('offline', setOffline);
        };
    }, [setOffline, setOnline]);

    return status;
};
